<template>
  <a-modal
    :title="title"
    centered
    :width="800"
    :mask-closable="false"
    :visible="showUploadForm"
    :confirmLoading="loading"
    @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      >
        <a-spin :spinning="loading">

          <a-form-model-item label="媒体" prop="media">
            <a-input v-model="model.media_name" :disabled="true"/>
          </a-form-model-item>

          <a-form-model-item label="来源广告主" required v-if="model.up_type == 2 && (model.media == 1 || model.media == 2)">
            <a-select v-model="sourceAdvertiserId" placeholder="请选择来源广告主" allowClear>
              <a-select-option v-for="item in sourceAdvertisers" :key="item.advertiser_id" :value="item.advertiser_id">
                {{ item.advertiser_name }}（{{ item.advertiser_id }}）
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="广告主" prop="advertiser_id" help="一行一个广告主，需要同一个主体" v-if="model.up_type == 2 || model.up_type == 3">
            <a-textarea v-model="model.advertiser_id" placeholder="请填写广告主" :auto-size="{ minRows: 20 }" />
          </a-form-model-item>
  
          <a-form-model-item label="广告主" prop="advertiser_id" v-else-if="model.mediaStr !== 'juliang'">
            <adv-select v-if="model.mediaStr === 'kuaishou'" v-model="model.advertiser_id" :max-tag-count="1" :type="model.mediaStr" />
            <adv-select v-else v-model="model.advertiser_id" :type="model.mediaStr" />
          </a-form-model-item>

          <a-form-model-item label="广告主" v-else-if="model.mediaStr === 'juliang'">
            <a-tabs v-model="advertiserMode" size="small" @change="onAdvertiserModeChange">
              <a-tab-pane key="single" tab="单广告主">
                <adv-select v-model="model.advertiser_id" :max-tag-count="1" :type="model.mediaStr" />
              </a-tab-pane>
              <a-tab-pane key="multi" tab="多广告主">
                <adv-select v-model="model.advertiser_id" :max-tag-count="5" :type="model.mediaStr" />
              </a-tab-pane>
            </a-tabs>
            <div style="color: rgba(0,0,0,0.45); font-size: 12px; margin-top: 4px;">
              每个主体只需要上传一个广告主，批量任务会自动推送到相关广告主
            </div>
          </a-form-model-item>

          <!-- 本地上传同步：快手素材库按文件MD5去重，已入库素材无法改来源，故仅支持从未同步过的新素材 -->
          <div v-if="model.up_type === 4" :style="{ marginLeft: labelCol.span / 24 * 100 + '%', padding: '0 12px 12px' }">
            <a-alert
              type="info"
              show-icon
              message="已同步过的素材会自动跳过"
              description="快手素材库按文件MD5去重：素材若已存在同步记录（含此前通过MAPI同步的），提交时会自动跳过，不会重复同步，也不会改变其已有来源。"
            />
          </div>

        </a-spin>
      </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Create';
</style>

<script>
import Create from './Create'
export default Create
</script>
